/*
 * "Partidos abiertos" (Falta un jugador) settings of a club: whether players may open a match on a free
 * court slot and how many hours before the slot an incomplete match closes. Pure data helpers, no React.
 * Contract with the back: `openMatches: { enabled: boolean, closeHours: integer 1..24 }` on
 * POST /organizer/clubs/update (and /add) and on GET /organizer/clubs/:id.
 */

export const DEFAULT_CLOSE_HOURS = 3;

/** 1..24 hours before the slot, as {value, label} options for the select. */
export const CLOSE_HOURS_OPTIONS = Array.from({ length: 24 }, (_, i) => ({
  value: i + 1,
  label: `${i + 1} h antes del turno`,
}));

export const defaultOpenMatches = () => ({ enabled: false, closeHours: DEFAULT_CLOSE_HOURS });

/** Club as loaded from the back -> form state. Clubs that predate the feature get the defaults. */
export const normalizeOpenMatches = (raw) => {
  const hours = Number(raw?.closeHours);
  return {
    enabled: raw?.enabled === true,
    closeHours: Number.isInteger(hours) && hours >= 1 && hours <= 24 ? hours : DEFAULT_CLOSE_HOURS,
  };
};

/** Form state -> body field. The select may hand back a string, the back wants an integer. */
export const buildOpenMatchesPayload = (value) => ({
  enabled: Boolean(value?.enabled),
  closeHours: Number(value?.closeHours),
});
